module.exports = __webpack_public_path__ + "static/media/dish@2x.167984dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/dish@2x.png
// module id = 733
// module chunks = 0